import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { adsPageView } from "../lib/ads";

// One page_view per settled route (redirects within 400ms collapse into the final page).
export const AdsPageViews = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const t = setTimeout(() => adsPageView(pathname), 400);
    return () => clearTimeout(t);
  }, [pathname]);
  return null;
};
